module.exports = "../dist/img/img_4-25.81fd.jpg";